// eslint-disable-next-line import/no-extraneous-dependencies
import memoizeOne from 'memoize-one';
function generateEmptyRows(emptyCells, length) {
  const itemsArray = Array.from({
    length
  });
  return itemsArray.map(() => ({
    cells: emptyCells
  }));
}
export const generateEmptyRow = memoizeOne(headerCells => {
  return headerCells.map(cell => ({
    key: cell.key,
    content: ''
  }));
});
export const prependRows = memoizeOne((emptyCells, itemsPerPage, pageNumber) => {
  if (!itemsPerPage || !pageNumber) {
    return [];
  }
  const itemsCount = (pageNumber - 1) * itemsPerPage;
  return generateEmptyRows(emptyCells, itemsCount);
});
export const appendRows = memoizeOne((emptyCells, rowsLength, itemsPerPage, pageNumber, totalItems) => {
  if (!itemsPerPage || !pageNumber || !totalItems) {
    return [];
  }
  const rowsDiff = rowsLength > itemsPerPage ? rowsLength - itemsPerPage : 0;
  const itemsCount = (Math.ceil(totalItems / itemsPerPage) - pageNumber) * itemsPerPage - rowsDiff;
  return generateEmptyRows(emptyCells, itemsCount);
});
export default function generateRowValues({
  itemsPerPage,
  pageNumber,
  totalItems,
  rowValues,
  headerCells
}) {
  const emptyCells = generateEmptyRow(headerCells);
  return [...prependRows(emptyCells, itemsPerPage, pageNumber), ...rowValues, ...appendRows(emptyCells, rowValues.length, itemsPerPage, pageNumber, totalItems)];
}